import axios from 'axios';
import events from 'Assets/js/components/events';
import rateLimit from 'axios-rate-limit';
import globalTheme from 'Assets/js/components/globalTheme';

const http = rateLimit(axios.create(), {
  maxRequests: 6,
  perMilliseconds: 1000,
  maxRPS: 6
});

const triggerErrorLog = (error) => {
  axios.post('/wp-json/teams/v1/send', {
    error: { 'service: ': 'menuService', error }
  });
};

function MenuServiceConstructor() {

  const getUSP = async (callback = undefined) => {
    const data = JSON.stringify({
      query: `query {
                usp {
                  message
                  link
                  icon
                  market
                  type
                  trustpilot {
                    stars
                    link
                  }
                }
            }`
    });

    const config = {
      method: 'post',
      url: `/graphql`,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    };

    http(config)
      .then((response) => {
        if (
          callback !== undefined &&
          response.data.data.usp !== undefined
        ) {
          const usp = response.data.data.usp;
          callback(usp);
        }
      })
      .catch((error) => {
        console.error('GraphQL Request Failed:', error);
        triggerErrorLog(error);
      });
  };

  const getBrandMenu = async (brand, callback = undefined) => {
    const brand_menu = brand + '_menu';
    if (callback !== undefined) {
      const menu = await getMenu(brand_menu);
      callback(menu);
    }
  }

  const getBrandMenus = async (callback = undefined) => {
    const brands = {};
    const brandList = Object.values(globalTheme.brands());

    for (const brand of brandList) {
      const brand_menu = brand + '_menu';
      brands[brand] = await getMenu(brand_menu);
    }

    if (callback) {
      callback(brands);
    }
  };

  const getBrandsMenu = async (callback = undefined) => {
    if (callback !== undefined) {
      const menu = await getMenu('brand_menu');
      callback(menu);
    }
  }

  const getMenu = (location) => {
    const data = JSON.stringify({
      query: `query {
                mdcMenus(location: "${location}") {
                    name
                    brand
                    logo {
                      src
                      alt
                      height
                      width
                    }
                    items {
                      id
                      title
                      url
                      childItems{
                        id
                        title
                        url
                        classes
                        mitypes_image
                        mitypes_paragraph
                        childItems{
                          id
                          title
                          classes
                          url
                          mitypes_image
                          mitypes_buttons
                          mitypes_paragraph
                        }
                      }
                    }
                }
            }`
    });

    const config = {
      method: 'post',
      url: `/graphql`,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    };

    return http(config)
      .then((response) => {
        if (
          response.data.data.mdcMenus !== undefined
        ) {
          return response.data.data.mdcMenus;
        }
      })
      .catch((error) => {
        console.error('GraphQL Request Failed:', error);
        triggerErrorLog(error);
      });
  };

  return {
    getBrandsMenu,
    getBrandMenus,
    getBrandMenu,
    getUSP,
    events: () => events
  };
}

const menuService = (function () {
  const instance = new MenuServiceConstructor();
  return {
    getInstance: () => instance
  };
})();

export default menuService;
